import React, { memo, useCallback, useMemo } from "react";
import Button from "../../../../../../shared-components/css-modules/toyota/atoms/Button";
import Icon from "../../../../../../shared-components/css-modules/toyota/atoms/Icon";
import a11y from "../../../../../../shared-components/css-modules/toyota/utils/Accessibility.module.scss";
import styles from "../ConfigCtas.module.scss";
import { trackClickSideQuickLinks } from "../../../../../utils/tracking";
import Popover from "../../../../../../shared-components/css-modules/toyota/vendor/popover/Popover";
import { useCarConfigSelector } from "../../../../../redux/store";
import CtaButton from "../CtaButton";
import Tooltip from "../../../../../../shared-components/css-modules/toyota/vendor/tooltip/Tooltip";
import Text from "../../../../../../shared-components/css-modules/toyota/atoms/Text";
import { ctaConfigSelector } from "../../../../../utils/selectorUtils";
import { CarConfigLabel } from "../../../../../utils/labelUtils";
import { useAphBreakpoint } from "../../../../../../shared-logic/hooks/useBreakpoint";

const QuickLinks: React.FC = () => {
    const isMobile = useAphBreakpoint("down", "xl");
    const quicklinkCtaConfig = useCarConfigSelector((state) => ctaConfigSelector(state, "quicklinkCtas", isMobile));
    const section = useCarConfigSelector((state) => state.carConfigNavigation.activeSection);

    const onClick = useCallback(
        (isOpen: boolean) => {
            if (isOpen) {
                trackClickSideQuickLinks(section);
            }
        },
        [section],
    );

    return useMemo(
        () =>
            quicklinkCtaConfig && quicklinkCtaConfig.length > 0 ? (
                <Popover placement="left" onOpenChangeListen={onClick}>
                    <Tooltip placement="left">
                        <Popover.Trigger>
                            <Tooltip.Trigger>
                                <Button variant="clean" className={styles.link}>
                                    <Icon variant="menu-two-dashes" sizing="md" aria-hidden="true" />
                                    <span className={a11y["sr-only"]}>
                                        <CarConfigLabel label="carConfigActionsQuickLinksButtonLabel" />
                                    </span>
                                </Button>
                            </Tooltip.Trigger>
                        </Popover.Trigger>
                        <Popover.Content variant="action-panel">
                            <div className={styles.quicklinkpanel}>
                                <Text tag="h3" variant="apheleia-body">
                                    <strong>
                                        <CarConfigLabel label="carConfigActionsQuickLinksTitle" />
                                    </strong>
                                </Text>
                                <ul role="list" className={styles.quicklinks}>
                                    {quicklinkCtaConfig.map((cta) => (
                                        <li
                                            className={styles["quicklinks-listitem"]}
                                            key={`${cta.type as string}-${cta.title}`}
                                        >
                                            <CtaButton
                                                ctaConfig={cta}
                                                sizing="full-width"
                                                className={styles["quicklinks-link"]}
                                            />
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </Popover.Content>
                        <Tooltip.Content className={styles.popover}>
                            <CarConfigLabel label="carConfigActionsQuickLinksButtonLabel" />
                        </Tooltip.Content>
                    </Tooltip>
                </Popover>
            ) : null,
        [quicklinkCtaConfig],
    );
};

export default memo(QuickLinks);
